import React from "react";
import { Card, CardBody, Badge, Button } from "reactstrap";
import PropTypes from "prop-types";
import { ContentLoader } from "../../../../components/Common";
import { GLOBAL_STATUS } from "../../../../constants/common";
import { GLOBAL_STATUS_LABELS } from "../../../../constants/common";;

const BankAccountSidebar = ({ accounts, activeId, onSelect, onCreateNew, loading }) => {
    return (
        <Card className="border-0 shadow-sm h-100 overflow-hidden d-flex flex-column rounded-0">
            <div className="bg-white p-3 border-bottom sticky-top" style={{ zIndex: 10 }}>
                <div className="d-flex align-items-start mb-3">
                    <i className="mdi mdi-bank text-primary font-size-22 me-2 mt-1"></i>
                    <div className="ms-2">
                        <h6 className="mb-0 fw-bold">Contas Bancárias</h6>
                    </div>
                </div>

                <Button
                    color="primary"
                    className="w-100 border-0 fw-bold shadow-sm rounded-0 py-2 d-flex align-items-center justify-content-center"
                    onClick={onCreateNew}
                >
                    <i className="mdi mdi-plus-circle-outline font-size-16 me-2"></i>
                    Nova Conta
                </Button>
            </div>

            <div className="flex-grow-1 overflow-auto bg-light-subtle p-2">
                {loading && accounts.length === 0 ? (
                    <div className="py-5">
                        <ContentLoader message="Carregando contas..." />
                    </div>
                ) : accounts.length === 0 ? (
                    <div className="text-center p-4">
                        <i className="mdi mdi-bank-outline font-size-32 text-muted mb-3"></i>
                        <p className="text-muted font-size-13">Nenhuma conta cadastrada.</p>
                    </div>
                ) : (
                    <div className="d-flex flex-column gap-2">
                        {accounts.map((acc) => (
                            <div
                                key={acc.id}
                                className={`card mb-0 cursor-pointer border rounded-0 transition-all ${activeId === acc.id ? 'border-primary shadow-sm ring-1 ring-primary' : 'border-light shadow-none hover-border-primary'}`}
                                onClick={() => onSelect(acc)}
                                style={{
                                    backgroundColor: activeId === acc.id ? '#f3f8ff' : '#fff'
                                }}
                            >
                                <CardBody className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="overflow-hidden">
                                            <h6 className="font-size-14 fw-bold mb-1 text-dark text-truncate">
                                                {acc.description}
                                            </h6>
                                            <div className="text-muted font-size-12 d-flex align-items-center gap-1">
                                                <i className="mdi mdi-bank-outline"></i>
                                                {acc.bankName}
                                            </div>
                                        </div>
                                        <Badge color={acc.status === GLOBAL_STATUS.ACTIVE ? "soft-success" : "soft-danger"} pill className="text-uppercase" style={{ fontSize: '9px' }}>
                                            {GLOBAL_STATUS_LABELS[acc.status] || 'Desconhecido'}
                                        </Badge>
                                    </div>
                                    <div className="mt-2 text-muted font-size-11 d-flex gap-2">
                                        <span className="badge bg-light text-muted border py-1">
                                            {acc.accountType}
                                        </span>
                                    </div>
                                </CardBody>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </Card>
    );
};

BankAccountSidebar.propTypes = {
    accounts: PropTypes.array.isRequired,
    activeId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onCreateNew: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default BankAccountSidebar;
